/* tslint:disable */
/* eslint-disable */
/**
 * Melco Rest Services
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MelcoModelsRole
 */
export interface MelcoModelsRole {
    /**
     * 
     * @type {string}
     * @memberof MelcoModelsRole
     */
    id?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MelcoModelsRole
     */
    code?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MelcoModelsRole
     */
    name?: string | null;
}

export function MelcoModelsRoleFromJSON(json: any): MelcoModelsRole {
    return MelcoModelsRoleFromJSONTyped(json, false);
}

export function MelcoModelsRoleFromJSONTyped(json: any, ignoreDiscriminator: boolean): MelcoModelsRole {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'code': !exists(json, 'code') ? undefined : json['code'],
        'name': !exists(json, 'name') ? undefined : json['name'],
    };
}

export function MelcoModelsRoleToJSON(value?: MelcoModelsRole | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'code': value.code,
        'name': value.name,
    };
}


